<template>
    <div>
        <v-card v-if="user_data" :class="$style.userFormMain" flat >
            <v-icon v-if="!forceSubmit" @click="resetForm(); $emit('close')" color="black" :class="$style.editProfileCloseBtn">fa-times-circle</v-icon>
            <div>
                <v-card :class="['userInitial', $style.userInitial]">
                    <p style="color: #3f9ae6; font-size: 24pt; font-weight: 500; margin: 0;">
                        {{user_data.firstname.charAt(0)}}{{user_data.lastname.charAt(0)}}
                    </p>
                </v-card>
            </div>
            <h5 :class="$style.editProfileTitle">
                <str index="edit_profile > title"/>
            </h5>
            <v-form 
                ref="userFormEditProfile" 
                v-model="valid.userFormEditProfile" 
                v-on:submit.prevent="save"
                >

                <v-container fluid :class="$style.userInputFieldsWrapper">
                    <v-layout row wrap style="padding: 13px 30px 0;">
                        <v-flex xs8 sm3>
                            <div :class="$style.editProfileCategory">
                                <v-icon style="margin-top: -6px;" v-if="categoryExpand.personal" 
                                        @click="categoryExpand.personal = !categoryExpand.personal">
                                    fas fa-caret-down
                                </v-icon>
                                <v-icon style="margin-top: -6px;" v-else @click="categoryExpand.personal = !categoryExpand.personal">
                                    fas fa-caret-right
                                </v-icon>
                                <p><str index="edit_profile > personal title" /></p>
                            </div>
                        </v-flex>
                        <v-flex xs4 sm9 align-self-center>
                            <div style="border: 1px solid whitesmoke;"></div>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-space-around v-show="categoryExpand.personal" my-3>

                        <!-- Title Input -->
                        <v-flex xs12 sm3>
                            <div :class="$style.editProfileField">
                                <p :class="$style.editProfileLabel">
                                    <str index="form > title"/>
                                </p>
                                <v-select 
                                    :class="['editProfileInput',$style.inputField]" 
                                    :items="subject_title" 
                                    v-model="user_data.title"
                                    dense
                                    outlined>  
                                </v-select>
                            </div>
                        </v-flex>

                        <!-- Firstname Input -->
                        <v-flex xs5 sm3>
                            <div :class="$style.editProfileField">
                                <p :class="$style.editProfileLabel">
                                    <sup>*</sup><str index="form > firstname"/>
                                </p>
                                <v-text-field 
                                    @keyup="proper('user_data.firstname' , user_data.firstname)" 
                                    :class="['editProfileInput',$style.inputField]" 
                                    outlined 
                                    :rules="formRules().validFirstName"
                                    v-model='user_data.firstname' 
                                    required
                                    dense>
                                    <template v-slot:message="{ message }">
                                        <str :index="message" />
                                    </template>
                                </v-text-field>
                            </div>
                        </v-flex>

                        <!-- Lastname Input -->
                        <v-flex xs5 sm3>
                            <div :class="$style.editProfileField">
                                <p :class="$style.editProfileLabel">
                                    <sup>*</sup><str index="form > lastname"/>
                                </p>
                                <v-text-field 
                                    @keyup="proper('user_data.lastname' , user_data.lastname)" 
                                    :class="['editProfileInput',$style.inputField]" 
                                    outlined 
                                    v-model='user_data.lastname' 
                                    :rules="formRules().validLastName"
                                    required>
                                    <template v-slot:message="{ message }">
                                        <str :index="message" />
                                    </template>
                                </v-text-field>
                            </div>
                        </v-flex>

                        <!-- Gender Input -->
                        <v-flex xs5 sm3>
                            <div :class="$style.editProfileField">
                                <p :class="$style.editProfileLabel">
                                    <str index="form > gender"/>
                                </p>
                                <v-select 
                                    :class="['editProfileInput',$style.inputField]" 
                                    :items="subject_gender" 
                                    v-model="user_data.gender"
                                    dense
                                    outlined/> 
                            </div> 
                        </v-flex>

                        <!-- Age Input -->
                        <v-flex xs5 sm3>
                            <div :class="$style.editProfileField">
                                <p :class="$style.editProfileLabel">
                                    <str index="form > age"/>
                                </p>
                                <v-select 
                                    :class="['editProfileInput',$style.inputField]" 
                                    :items="personal_age" 
                                    v-model="user_data.age"
                                    dense
                                    outlined/>   
                            </div>
                        </v-flex>

                        <!-- Contact Number Input -->
                        <v-flex xs5 sm3>
                            <div :class="$style.editProfileField">
                                <p :class="$style.editProfileLabel">
                                    <str index="form > contact_number"/>
                                </p>
                                <v-text-field 
                                    @keyup="proper('user_data.contactNumber' , user_data.contactNumber)" 
                                    :class="['editProfileInput',$style.inputField]" 
                                    outlined 
                                    v-model='user_data.contact_number' 
                                    required
                                    dense/>
                            </div>
                        </v-flex>

                        <!-- Secondary Email -->
                        <v-flex xs5 sm3>
                            <div :class="$style.editProfileField">
                                <p :class="$style.editProfileLabel">
                                    <str index="form > secondary_email"/>
                                </p>
                                <v-text-field 
                                    @keyup="lowerCase('user_data.secondaryEmail' , user_data.secondaryEmail)" 
                                    :class="['editProfileInput',
                                            $style.inputField]" 
                                            outlined 
                                            dense
                                            v-model='user_data.secondary_email'
                                            :rules="formRules().validSecondaryEmail"
                                            validate-on-blur >    
                                    <template v-slot:message="{ message }">
                                        <str :index="message" />
                                    </template>
                                </v-text-field>
                            </div>  
                        </v-flex>

                        <v-flex xs5 sm3></v-flex>

                        <!-- Country Input -->
                        <v-flex xs5 sm3>
                            <div :class="$style.editProfileField">
                                <p :class="$style.editProfileLabel">
                                    <sup>*</sup><str index="form > country"/>
                                </p>
                                <v-autocomplete
                                    :class="['editProfileInput',$style.inputField]" 
                                    v-model="user_data.country"
                                    :items="list_countries"
                                    :rules="formRules().validCountry"
                                    hide-selected
                                    dense
                                    outlined
                                >
                                    <template v-slot:message="{ message }">
                                        <str :index="message" />
                                    </template>
                                </v-autocomplete>
                            </div>
                        </v-flex>

                        <!-- Province Input -->
                        <v-flex xs5 sm3>
                            <div :class="$style.editProfileField">
                                <p :class="$style.editProfileLabel">
                                    <sup>*</sup> <str index="form > province"/>
                                </p>
                                <v-autocomplete
                                    :class="['editProfileInput',$style.inputField]" 
                                    :items="list_states" 
                                    item-text="text"
                                    item-value="value"
                                    v-model="user_data.province"
                                    :rules="formRules().validProvinceState"
                                    :disabled="!user_data.country"
                                    dense
                                    outlined>  
                                    <template v-slot:message="{ message }">
                                        <str :index="message" />
                                    </template>
                                </v-autocomplete>
                            </div>                  
                        </v-flex>

                        <!-- City Input -->
                        <v-flex xs5 sm3>
                            <div :class="$style.editProfileField">
                                <p :class="$style.editProfileLabel">
                                    <sup>*</sup><str index="form > city"/>
                                </p>
                                <v-text-field 
                                    @keyup="proper('user_data.city' , user_data.city)" 
                                    :class="['editProfileInput',$style.inputField]" 
                                    outlined 
                                    dense
                                    v-model='user_data.city' 
                                    :rules="formRules().validCity"
                                    required>
                                    <template v-slot:message="{ message }">
                                        <str :index="message" />
                                    </template>
                                </v-text-field>
                            </div>
                        </v-flex>

                        <v-flex xs5 sm3 />

                        <!-- Address Input -->
                        <v-flex xs12 sm4>
                            <div :class="$style.editProfileAddressField">
                                <p :class="$style.editProfileLabel">
                                    <str index="form > address"/>
                                </p>
                                <v-text-field 
                                    @keyup="upperCase('user_data.address' , user_data.address)" 
                                    :class="['editProfileInput',$style.inputField]" 
                                    outlined 
                                    dense
                                    v-model='user_data.address' 
                                    required>
                                    <template v-slot:message="{ message }">
                                        <str :index="message" />
                                    </template>
                                </v-text-field>
                            </div>
                        </v-flex>

                        <v-flex xs7></v-flex>

                        <v-row >
                            <!-- HCP Job Profession Input -->
                            <v-col cols="6" class="d-flex justify-center">
                                <div :class="$style.editProfileFieldWrapper">
                                    <p :class="$style.editProfileLabel">
                                        <sup>*</sup> <str index="form > hcp_job_profession"/>
                                    </p>
                                    <v-autocomplete  
                                        style="white-space: nowrap; overflow: hidden;"
                                        :class="['editProfileInput',$style.inputField]" 
                                        :items="list_hcp_job_profession" 
                                        v-model="user_data.hcp_job_profession"
                                        :rules="formRules().validHcpJobProfession"
                                        dense
                                        outlined>
                                        <template v-slot:message="{ message }">
                                            <str :index="message" />
                                        </template>
                                        <template slot="selection" slot-scope="data" dense>
                                            <!-- HTML that describe how select should render selected items -->
                                            {{data.item.text}}
                                        </template>

                                        <v-list-item-content slot="item" slot-scope="data" dense>
                                            <!-- HTML that describe how select should render items when the select is open -->
                                            <v-list-item-title>{{data.item.text}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-autocomplete>
                                </div>
                            </v-col>

                            <!-- Specialty Input -->
                            <v-col cols="6" class="d-flex justify-center">
                                <div :class="$style.editProfileFieldWrapper">
                                    <p :class="$style.editProfileLabel">
                                        <sup>*</sup> <str index="form > specialty"/>
                                    </p>
                                    <v-autocomplete  
                                        style="white-space: nowrap; overflow: hidden;"
                                        :class="['editProfileInput',$style.inputField]" 
                                        :items="list_specialty" 
                                        v-model="user_data.specialty"
                                        :rules="formRules().validSpecialty"
                                        dense
                                        outlined>
                                        <template v-slot:message="{ message }">
                                            <str :index="message" />
                                        </template>
                                        <template slot="selection" slot-scope="data" dense>
                                            <!-- HTML that describe how select should render selected items -->
                                            {{data.item.text}}
                                        </template>

                                        <v-list-item-content slot="item" slot-scope="data" dense>
                                            <!-- HTML that describe how select should render items when the select is open -->
                                            <v-list-item-title>{{data.item.text}}</v-list-item-title>
                                        </v-list-item-content>                                
                                    </v-autocomplete>
                                </div>
                            </v-col>
                        </v-row>

                        <v-row>
                            <!-- Medical License Input -->
                            <v-col cols="6" class="d-flex justify-center">
                                <div :class="$style.editProfileFieldWrapper">
                                    <p :class="$style.editProfileLabel">
                                        <str index="form > license"/>
                                    </p>
                                    <v-text-field 
                                        :class="['editProfileInput',$style.inputField]" 
                                        outlined 
                                        v-model='user_data.license' 
                                        required
                                        dense/>
                                </div>
                            </v-col>

                            <!-- Company Input -->
                            <v-col cols="6" class="d-flex justify-center">
                                <div :class="$style.editProfileFieldWrapper">
                                    <p :class="$style.editProfileLabel">
                                        <str index="form > company"/>
                                    </p>
                                    <v-text-field 
                                        :class="['editProfileInput',$style.inputField]"
                                        outlined 
                                        v-model='user_data.company' 
                                        required
                                        dense/>
                                </div>
                            </v-col>
                        </v-row>
                    </v-layout>
                                    
                    <v-layout  row wrap mt-5 style="background-color: #f9f9f9; padding: 13px 30px 0;">
                        <v-flex xs8 sm3>
                            <div :class="$style.editProfileCategory">
                                <v-icon style="margin-top: -6px;" v-if="categoryExpand.account" 
                                        @click="categoryExpand.account = !categoryExpand.account">
                                    fas fa-caret-down
                                </v-icon>
                                <v-icon style="margin-top: -6px;" v-else @click="categoryExpand.account = !categoryExpand.account">
                                    fas fa-caret-right
                                </v-icon>
                                <p  @click="categoryExpand.account = !categoryExpand.account"><str index="edit_profile > account title" /></p>
                            </div>
                        </v-flex>
                        <v-flex xs4 sm9 align-self-center>
                            <div style="border: 1px solid whitesmoke;"></div>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap justify-space-around v-show="categoryExpand.account" pt-5 style="background-color: #f9f9f9;">
                        
                        <!-- E-mail -->
                        <v-flex xs5 sm3>
                            <div :class="$style.editProfileField">
                                <p :class="$style.editProfileLabel">
                                    <str index="form > email"/>
                                </p>
                                <v-text-field 
                                    @keyup="lowerCase('user_data.email' , user_data.email)" 
                                    disabled
                                    :class="['editProfileInput',
                                            $style.inputField]" 
                                            outlined 
                                            dense
                                            v-model='user_data.email' 
                                            validate-on-blur 
                                            :rules="formRules().validEmail" >    
                                    <template v-slot:message="{ message }">
                                        <str :index="message" />
                                    </template>
                                </v-text-field>
                            </div>
                        </v-flex>

                        <!-- Confirm E-mail -->
                        <!-- <v-flex xs5 sm3>
                            <div :class="$style.editProfileField">
                                <p :class="$style.editProfileLabel">
                                    <str index="form > confirm_email"/>
                                </p>
                                <v-text-field 
                                    @keyup="lowerCase('confirm.email', confirm.email)" 
                                    :class="['editProfileInput',
                                            $style.inputField]" 
                                    outlined 
                                    dense
                                    v-model='confirm.email'
                                    :rules="formRules(user_data.email, null).validConfirmEmail">
                                    <template v-slot:message="{ message }">
                                        <str :index="message" />
                                    </template>
                                </v-text-field>
                            </div>
                        </v-flex> -->
                        
                            <template v-if="!changePwBtn">
                                <v-flex xs10 sm6>
                                    <v-btn 
                                        :class="$style.clickChangePwBtn" 
                                        color="#3f9ae6" 
                                        dark
                                        @click="changePwBtn = true">
                                        <span>
                                            <str index="form > change_password"/>
                                        </span>
                                    </v-btn>
                                </v-flex>
                            </template>

                            <template v-else>
                                <!-- Current Password -->
                                <v-flex xs5 sm3>
                                    <div :class="$style.editProfileField">
                                        <p :class="$style.editProfileLabel">
                                            <str index="form > current_password"/>
                                        </p>                            
                                        <v-text-field 
                                        :class="['editProfilePwInput',
                                                $style.inputField]" 
                                        :type="config.currentPasswordType"  
                                        :disabled="passwordCorrect"
                                        outlined 
                                        v-model='current_password'>
                                            <v-icon small slot="append" @click="togglePasswordType('currentPasswordType')" 
                                                     v-if="config.currentPasswordType != 'password'">fa-eye</v-icon>
                                            <v-icon small slot="append" @click="togglePasswordType('currentPasswordType')" v-else>
                                                fas fa-eye-slash
                                            </v-icon>
                                            <template v-slot:message="{ message }">
                                                <str :index="message" />
                                            </template>
                                        </v-text-field>
                                    </div>
                                </v-flex>

                                <!-- Validate Password -->
                                <v-flex xs5 sm3>
                                    <v-btn 
                                        :class="$style.changePwBtn" 
                                        :disabled="current_password == null || current_password == '' || passwordCorrect" 
                                        color="#3f9ae6" 
                                        depressed
                                        :dark="current_password != null && current_password != ''"
                                        @click="checkPassword(current_password)">
                                        <v-progress-circular
                                            indeterminate
                                            color="white"
                                            v-if="startCheckingPw"
                                        >
                                        </v-progress-circular>
                                        <span v-else-if="!passwordCorrect">
                                            <str index="form > validate_password"/>
                                        </span>
                                        <v-icon :class="$style.validatedIcon" v-else style="color: #52c100 !important;">
                                            far fa-check-circle
                                        </v-icon>
                                    </v-btn>
                                </v-flex>
                            </template>

                        <!-- Prefered Language -->
                        <v-flex xs5 sm3>
                            <div :class="$style.editProfileField">
                                <p :class="$style.editProfileLabel">
                                    <str index="form > prefered_language"/>
                                </p>
                                <v-select 
                                    :class="['editProfileInput',$style.inputField]" 
                                    :items="list_languages" 
                                    outlined
                                    dense
                                    v-model="user_data.language"/>
                            </div>
                        </v-flex>

                        <v-flex xs5 sm3></v-flex>

                        <!-- New Password -->
                        <v-flex xs5 sm3>
                            <div :class="$style.editProfileField" v-if="passwordCorrect">
                                <p :class="$style.editProfileLabel">
                                    <str index="form > new_password"/>
                                </p>
                                <v-text-field 
                                    :class="['editProfilePwInput',
                                            $style.inputField]" 
                                    :type="config.newPasswordType" 
                                    outlined 
                                    v-model='new_password' 
                                    :rules="formRules().validPassword">
                                        <v-icon small slot="append" @click="togglePasswordType('newPasswordType')" 
                                                 v-if="config.newPasswordType != 'password'">fa-eye</v-icon>
                                        <v-icon small slot="append" @click="togglePasswordType('newPasswordType')" v-else>
                                            fas fa-eye-slash
                                        </v-icon>
                                        <template v-slot:message="{ message }">
                                            <str :index="message" />
                                        </template>
                                </v-text-field>
                            </div>
                        </v-flex>

                        <!-- Confirm Password -->
                        <v-flex xs5 sm3>
                            <div :class="$style.editProfileConfirmPwField" v-if="passwordCorrect">
                                <p :class="$style.editProfileLabel">
                                    <str index="form > confirm_password"/>
                                </p>
                                <v-text-field 
                                    :class="['editProfilePwInput',
                                            $style.inputField]" 
                                    :type="config.newPasswordConfirmType" 
                                    outlined 
                                    v-model='confirm.password'
                                    :rules="formRules(user_data.email, new_password).validConfirmPassword">
                                        <v-icon small slot="append" @click="togglePasswordType('newPasswordConfirmType')" 
                                            v-if="config.newPasswordConfirmType != 'password'">fa-eye</v-icon>
                                        <v-icon small slot="append" @click="togglePasswordType('newPasswordConfirmType')" v-else>
                                            fas fa-eye-slash
                                        </v-icon>
                                        <template v-slot:message="{ message }">
                                            <str :index="message" />
                                        </template>
                                </v-text-field>
                            </div>
                        </v-flex>
                    
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex xs10 class="text-xs-center" style="padding-left: 3.5%;">
                            <input type="checkbox" name="consent" value="Y" v-model="consent" style="position: relative;" checked="Y"/>
                            <p :class="$style.termPolicyContent">
                                <str index="form > consent_register marketing"/>
                            </p>
                        </v-flex>
                        
                        <v-flex xs12 :class="$style.signBtnSection">
                            <v-btn depressed color="#3f9ae6" dark :class="$style.signUpBtn" @click="validationForm()">
                                <str index="button > save"/>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-card>
    </div>
</template>

<script>
import SpecialtyList from '@/plugins/SpecialtyList.js';
import CanadaProvinceFrenchTranslation from '@/plugins/CanadaProvinceFrenchTranslation.js'
export default {
    name: 'userFormEditProfile',
    props: {
        user: {
            type: Object,
            required: false
        }
    },
    mounted: function(){
        this.init();
    },
    data: function(){
        return {
            geoAPI: null,
            valid: {
                userFormEditProfile: false
            },
            categoryExpand: {
                personal: true,
                account: true
            },
            user_data: null,
            current_password: null,
            new_password: null,      
            confirm: {
                password: null,
                email: null
            }, 
            startCheckingPw: false,
            passwordCorrect: false,
            changePwBtn: false,
            config: {
                newPasswordType: "password",
                newPasswordConfirmType: "password",
                currentPasswordType: "password"
            },
            consent : false
        }
    },
    methods: {
        init: function(){
            this.user_data = this.userTemplate();
            if(this.user_data.id){
                this.confirm.email = this.user_data.email
            }
            if(this.user_data.casl_marketing === "Y") {
                this.consent = true;
            } else {
                this.consent
            }
            this.user_data.password = null;
            this.geoAPI = this.countrycitystatejson(); //require('countrycitystatejson');
            this.changePwBtn = false;
            this.passwordCorrect = false;
            this.clickedChangePw = false;
            this.new_password = null;
            this.confirm.password = null;
            this.current_password = null;
        },
        userTemplate: function(){
            let user = this.unlink(this.user);
            return {
                id: user.id ? user.id : null,
                email: user.email ? user.email: null,
                title: user.title ? user.title : null,
                firstname: user.firstname ? user.firstname : null,
                lastname: user.lastname ? user.lastname : null,
                gender: user.gender ? user.gender : null,
                age: user.age ? user.age : null,
                contact_number: user.contact_number ? user.contact_number : null,
                secondary_email: user.secondary_email ? user.secondary_email : null,
                country: user.country ? user.country : null,
                province: user.province && user.country ? user.province : "",
                city: user.city ? user.city : null,
                address: user.address ? user.address : null,
                specialty: user.specialty ? user.specialty : null,
                license:  user.license ? user.license : null,
                company: user.company ? user.company : null,
                language: user.language ? user.language : null,
                type: user.type ? user.type : 'user',
                notes: user.note ? user.note : null,
                active: user.active ? user.active : "N",
                validated: user.validated ? user.validated : null,
                casl_marketing: user.casl_marketing ? user.casl_marketing : null,
                hcp_job_profession: user.hcp_job_profession ? user.hcp_job_profession : null
            }
        },           
        lowerCase: function(target , data){
            data = data.toLocaleLowerCase();
            eval("this."+target+" = '"+data+"'");
        },
        upperCase: function(target , data){
            data = data.toLocaleUpperCase();
            eval("this."+target+" = '"+data+"'");
        },
        proper: function(target , data) {
            data = sentenceCase(data);
            eval("this."+target+" = '"+data+"'");

            function sentenceCase (str) {
                str = str.toString();

                return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
            }
        },
        save: function(){
            this.user_data.casl_marketing = this.consent ? "Y" : "N";
            this.$emit('saveEditProfile', {
                user: this.user_data, 
                password: this.new_password
            });
            this.changePwBtn = false;
            this.passwordCorrect = false;
            this.clickedChangePw = false;
            this.new_password = null;
            this.confirm.password = null;
            this.current_password = null;
        },
        checkPassword: function(pw) {
            this.startCheckingPw = true;
            var self = this;
            this.$controller.security.user.validate_password(this.user_data.id, pw).then(function(response) {
                if(response) {
                    self.passwordCorrect = true;
                    self.startCheckingPw = false;
                } else {
                    self.passwordCorrect = false;
                    self.startCheckingPw = false;
                    self.$emit('failedPasswordValidation');
                }
            });
        },
        resetForm: function() {
            
            this.$refs.userFormEditProfile.resetValidation();
            this.init();
        },
        validationForm: function() {
            if (this.$refs.userFormEditProfile.validate()) {
                this.save();
            }
        },
        togglePasswordType: function(typePw){
            this.config[typePw] = this.config[typePw]=='password' ? 'text' : 'password';
        },
    },
    computed: {
        /*
         * User auto migrated from Legacy Vivomap v2.5/3 submission is mandatory at first login to change `updated` attribute at users table.
         * As result created vs. update timestamp won't match and so WelcomeBackWizard won't popup again rather first login
         */
        forceSubmit: function(){
            return this.firstMigratedUserLogin();          
        },
        list_countries: function(){
            var geoAPI = this.geoAPI;
            var countries = geoAPI.getCountries();

            var list = [];
            for(let i in countries){
                var record = countries[i];
                list.push({
                    text: record.native,
                    value: record.shortName
                });
            }
            
            return list;
        },
        list_states: function(){
            if(this.user_data.country) {
                var geoAPI = this.geoAPI;
                var states = geoAPI.getStatesByShort(this.user_data.country);
                let result = [];
                for (let i =0; i < states.length; i++) {
                    if((this.user_data.country  === "CA" || this.user_data.country === "Canada") && this.$language() === "fr") {
                        result.push({
                            text: CanadaProvinceFrenchTranslation[states[i]],
                            value: states[i]
                        });
                    } else {
                        result.push({
                            text: states[i],
                            value: states[i]
                        });
                    }
                }
                return result
            } 
            return [];
        },
        list_hcp_job_profession: function() {
            let Language = this.$language()
            let List = this.$store.getters.specialties
            let Labels =  this.$store.getters.library.labels
            let output = [];
            for(let Key in List){
                let Label = Labels[`list_hcp_job_profession > ${Key}`] ? Labels[`list_hcp_job_profession > ${Key}`][Language] : `list_hcp_job_profession > ${Key}`
                output.push({
                    text: Label,
                    value: Key
                })
            }
            output.sort(function(a,b) {
                if(a.text < b.text) {return -1;}
                if(a.text > b.text) {return 1;}
                return 0;
            })
            return output;
        },
        list_specialty: function() {
            let output = []
            let hcp_job_profession = this.user_data.hcp_job_profession
            if(hcp_job_profession){
                let List = this.$store.getters.specialties[hcp_job_profession]
                let Language = this.$language()
                for(let i=0; i<List.length; i++){
                    let item = List[i]
                    output.push({
                        text: item.label[Language],
                        value: item.value
                    })
                }

                output.sort(function(a,b) {
                    if(a.text < b.text) {return -1;}
                    if(a.text > b.text) {return 1;}
                return 0;
            })                
                
            }

            return output
        },        
        // list_hcp_job_profession: function(){
        //     let needle = "list_hcp_job_profession > "
        //     let hcpJobProfessionLabelKeys = Object.keys(this.$store.getters.library.labels).filter(key => key.includes(needle))
        //     let hcpJobProfessionList = []
        //     let otherProfessionIndex = null
        //     for(let key in hcpJobProfessionLabelKeys){
        //         let value = this.$store.getters.library.labels[hcpJobProfessionLabelKeys[key]]['en']
        //         if (value==='Other'){
        //            otherProfessionIndex = key; 
        //         }
        //         hcpJobProfessionList.push({"text": this.labels(hcpJobProfessionLabelKeys[key]), "value":value})
        //     }
        //     let otherProfessionItem = hcpJobProfessionList.splice(otherProfessionIndex, 1)
        //     return [...hcpJobProfessionList, ...otherProfessionItem] 
        // },        
        // list_specialty: function() {
        //     let finalSpecialtyList = [];
        //     for (let i = 0; i < SpecialtyList.length; i++) {
        //         let specialty = {...SpecialtyList[i]};
        //         specialty.text = this.$store.getters.library.labels[specialty.text][this.$language()];
        //         finalSpecialtyList.push(specialty);
        //     }
        //     finalSpecialtyList.sort(function(a,b) {
        //         if(a.text < b.text) {return -1;}
        //         if(a.text > b.text) {return 1;}
        //         return 0;
        //     })
        //     return finalSpecialtyList;
        // },
        list_user_types: function(){
            return [
                {text:'user' , value:'user'},
                {text:'client' , value:'client'},
                {text:'staff' , value:'staff'},
                {text:'admin' , value:'admin'},
                {text:'rep' , value:'rep'}       
            ];
        },
        
        list_languages: function(){
            var list = [];
            if (this.$store.getters.library) {
                for(let i in this.$store.getters.library.languages){
                    list.push({
                        text: typeof(i) === 'string' ? i.toUpperCase() : i,
                        value: i
                    })
                }
            }
            return list;
        },


        allow: function(){
            return this.$store.getters.user && this.$store.getters.user.type=='admin';
        },

        subject_title: function() {
            var subject_title = [];
            switch (this.$language()) {
                case "en":
                    subject_title = [
                        {text: "Mr. ", value: "mr"},
                        {text: "Mrs.", value: "mrs"},
                        {text: "Miss.", value: "miss"},
                        {text: "Ms.", value: "ms"},
                        {text: "Dr.", value: "dr"}
                    ];
                    break;
                
                case "fr":
                    subject_title = [
                        {text: "Mr. ", value: "mr"},
                        {text: "Mrs.", value: "mrs"},
                        {text: "Miss.", value: "miss"},
                        {text: "Ms.", value: "ms"},
                        {text: "Dr.", value: "dr"},
                        {text: "Dre.", value: "dre"}
                    ]; 
                    break;
                
                default:
                    subject_title = [
                        {text: "Mr. ", value: "mr"},
                        {text: "Mrs.", value: "mrs"},
                        {text: "Miss.", value: "miss"},
                        {text: "Ms.", value: "ms"},
                        {text: "Dr.", value: "dr"}
                    ];
                    break;
            }

            return subject_title;
        },

        subject_gender: function() {
            var subject_gender = [
                {text: "Male", value: "male"},
                {text: "Female", value: "female"},
            ];

            return subject_gender;
        },

        personal_age: function() {
            var personal_age = [
                {text: "18 to 24", value: "18-24"},
                {text: "25 to 39", value: "25-39"},
                {text: "40 to 60", value: "40-60"},
                {text: "≥ 60", value: "60+"}
            ];
            
            return personal_age;
        },
        
        displayState: function(){
            return this.$store.getters.overlays.editProfile;
        },
    },
    watch : {
        'user_data.country': function(after, before) {
            if(after != before && typeof(before) !== 'undefined') {
                this.user_data.province = null;
            }
        },
        displayState: function(after, before){
            if (after===true && before===false){
                this.init();
            }
        }
    }
}
</script>

<style module>
.userInitial {
    padding-top: 0px; 
    display:flex !important;
    align-items:center; 
    justify-content: center;
    background-color:white !important;
    position:relative;
    top:6px;
    width:85px; 
    height:85px; 
    border-radius:50% !important;
    margin: 5px auto;
    z-index: 9;
}
.userInputFieldsWrapper {
    width: 100%; 
    margin: 0 auto; 
    max-height: 760px; 
    /* overflow-y: auto; */
} 

@media only screen and (max-width: 800px), screen and (max-height: 700px) {
    .userInitial {
        display:none !important;
    }

    .userInputFieldsWrapper {
        /* max-height: 540px; */
    }
}

.userInputFieldsWrapper::-webkit-scrollbar {
    width: 0.8em;
}

.userInputFieldsWrapper::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
}

.userInputFieldsWrapper::-webkit-scrollbar-thumb {
    background-color: #d7d7d7;
    outline: 1px solid slategrey;
    border-radius: 5px;
}

.userFormMain{
    position: relative;
    border-radius: 15px;
}
    .editProfileCategory i {
        cursor: pointer;
    }
    .editProfileCategory p{
        display: inline-block;
        margin-bottom: 0 !important; 
        margin-left: 8%;
        font-size: 14pt;
        font-weight: 400;
        color: black;
    }

    .editProfileCloseBtn {
        position: absolute;
        top: 10px;
        right: 15px;
    }

    .editProfileTitle {
        text-align: center;
        font-size: 24pt;
        font-weight: 400;
        color: black;
    }
  
    .editProfileField {
        width: 71%;
        margin: 0 auto;
    }
    
    .editProfileFieldWrapper {
        width: 85%;
    }

    .editProfileAddressField {
        width: 91%;
        margin: 0 auto;
    }

    .editProfileConfirmPwField {
        width: 91%;
    }

    .editProfileLabel {
        margin-bottom: 0px !important;
        margin-left: 0.5%;
        color: black;
        font-size: 10pt;
    } 

.userFormMain .inputField{
    width: 100%;
    font-size: 12px !important;
}

.editProfileConfirmPwField .inputField {
    width: 100%;
}

.confirmed input{
    color: green !important;
}
.failed input{
    color: red !important;
}

.validatedIcon {
    color: red !important;
}

.termPolicyContent {
    /* border: 1px solid red; */
    color: #333;
    font-size: 10pt;
    font-weight: 300;
    width: 91%;
    display: inline-flex;
    /* margin-bottom: 0 !important; */
    margin-left: 2%;
    position: relative;
    top: -2px;
}

.Specialty{
    max-width: 125px;
    text-overflow: ellipsis; 
    overflow: hidden;
}

@media only screen and (max-width: 1023px) {
.Specialty{
    max-width: 70px;
}
}

@media only screen and (max-width: 800px) {
    .editProfileCloseBtn {
            top: 30px;
        }
    .termPolicyContent {
        top: 10px;
    }
    .editProfileTitle {
        font-size: 18pt;
        padding-top: 5%;
	}
    .editProfileCategory p {
             font-size: 12pt;
    }    
}

.signBtnSection {
    padding-bottom: 1%; 
    text-align: center;
}

.signUpBtn {
    text-transform: initial;
}

.changePwBtn {
    text-transform: initial;
    margin-top: 7%;
}

.clickChangePwBtn {
    text-transform: initial !important;
    margin: 3% 0 30px 2%;
}

/* Gender Toggle */
.genderToggle {
    width: 80%;
    background-color: #99c1dd;
    border-radius: 5px;
    color: white;
    text-align: center;
}

.genderLabel {
    display: inline-block;
    padding: 2.5% ;
    /* text-align: center; */
}

.toggle_male, .toggle_female {
    display: none;
}

    .genderMaleLabel, .genderFemaleLabel {
        cursor: pointer;
        min-width: 70px;
        position: relative;
        z-index: 1;
        /* font-size: 10pt; */
    }

    .genderMaleLabel:hover, .genderFemaleLabel:hover {
        background: none;
    }

    .genderMaleLabel::after, .genderFemaleLabel::after {
        display: none;
        background-color: white;
        content: "";
        height: 80%;
        position: absolute;
        top: 3px;
        transition: left 200ms cubic-bezier(0.77, 0, 0.175, 1);
        width: 90%;
        border-radius: 5px;
        /* margin: 2.5% 0; */
        z-index: -1;
        -webkit-box-shadow: 10px 2px 5px 0px rgba(140,177,203,1);
        -moz-box-shadow: 5px 2px 5px 0px rgba(140,177,203,1);
        box-shadow: 5px 2px 5px 0px rgba(140,177,203,1);
    }

    .toggle_male:checked + .genderMaleLabel{
        cursor: default;
        color: black;
        transition: color 200ms;
    }
        .toggle_male:checked + .genderMaleLabel::after {
            display:initial;
            left: 3px;
        }

    .toggle_female:checked + .genderFemaleLabel {
        cursor: default;
        color: black;
        transition: color 200ms;
    }

        .toggle_female:checked + .genderFemaleLabel::after {
            right: 3px;
            display:initial;
        }
</style>



<style lang="scss" scroped>
.editProfilePwInput .v-input__control .v-input__slot, .editProfileInput .v-input__control .v-input__slot {
    min-height: auto !important;
    margin-bottom: 0;
}

.editProfilePwInput .v-input__control .v-select__slot, .editProfileInput .v-input__control .v-select__slot {
    height: 33px;
    margin-bottom: 0;
}

.editProfileInput .v-input__control .v-select__slot .v-input__append-inner {
    margin-top: 4px !important;
}

.editProfilePwInput .v-input__control .v-input__slot .v-input__append-inner {
    margin-top: 8px !important;
}

.userInitial .v-application .elevation-24 {
    box-shadow:none !important;
    -webkit-box-shadow:none !important;
}

.editProfileInput .v-input__control .v-text-field__details,  .editProfilePwInput .v-input__control .v-text-field__details{
    margin-top: 8px;
}

</style>